import { type ReactElement } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { ArrowLeft } from 'lucide-react'

import { logger } from '~/lib/logger'
import { ArticleForm, articlesQuery, useCreateArticle } from '~/features/help-kb'

/**
 * `/admin/help-kb/new` — write a brand new help article. A full page, not a
 * modal: see `ArticleForm`'s own header comment for why.
 */
export const Route = createFileRoute('/admin/help-kb/new')({
  component: NewArticlePage,
})

function NewArticlePage(): ReactElement {
  const navigate = useNavigate()
  const list = useQuery(articlesQuery())
  const createMutation = useCreateArticle()

  const modules = [...new Set((list.data?.articles ?? []).map((article) => article.module))].sort()

  const backTo = () => void navigate({ to: '/admin/help-kb' })

  return (
    <div className="ka-page">
      <header className="ka-page-header">
        <div>
          <button type="button" className="ka-btn ka-btn--ghost ka-btn--sm" onClick={backTo}>
            <ArrowLeft size={14} aria-hidden="true" /> Back
          </button>
          <h1 className="ka-page-header-title">New Article</h1>
        </div>
      </header>

      <ArticleForm
        article={null}
        modules={modules}
        onCancel={backTo}
        isSaving={createMutation.isPending}
        error={createMutation.error}
        onSave={(values) => {
          createMutation.mutate(values, {
            onSuccess: backTo,
            onError: (cause) => logger.warn('help-kb.create.failed', { cause }),
          })
        }}
      />
    </div>
  )
}
